import React, { useState, useEffect, useRef } from 'react';
import { Button, Col, Row, Modal, Tabs, Tab, Dropdown, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { useDispatch, useSelector } from "react-redux";
import APICom from "../../utils/helpers/APICom";
import '../../assets/Styles/DispatchCSS/DispatchCSS.css';
import ConfirmationModal from '../Controls/ConfirmationModal';

const EditRouteSettings = (props = {}) => {

  const { FamilyData, AffiliateData, DispatchVehicleData, VehicleTypesPerAffiliateData, FundingSourceData, ASCSSettingData, AttributeData } = useSelector((store) => store.combinedata);
  const { loginData } = useSelector((store) => store.login);
  const [CallAgentDefaultAffiliateID, setCallAgentDefaultAffiliateID] = useState(loginData.DefaultAffiliateID);
  const [showDynamicModal, setShowDynamicModal] = useState(props.invokeEditSetting);
  const [fileName, setFileName] = useState("");
  const [fileNameSelectedForDay, setFileNameSelectedForDay] = useState("");
  const [Duration, setDuration] = useState('');
  const [DurationSelectedForDay, setDurationSelectedForDay] = useState('');
  const [vehType, setVehType] = useState('SEDAN');
  const [vehTypeSelectedForDay, setVehTypeSelectedForDay] = useState('SEDAN');
  const [VehOptionsManageHTML, setVehOptionsManageHTML] = useState([]);
  const [VehTypeOptionsManageHTML, setVehTypeOptionsManageHTML] = useState([]);
  const [vehNum, setVehNum] = useState("-1");
  const [vehNumSelectedForDay, setVehNumSelectedForDay] = useState("-1");
  const [breakTimeRows, setBreakTimeRows] = useState([]);
  const [breakTimeRowsSelectedForDay, setBreakTimeRowsSelectedForDay] = useState([]);
  const [breakTimeRowInfo, setBreakTimeRowInfo] = useState([]);
  const [breakTimeRowInfoSelectedForDay, setBreakTimeRowInfoSelectedForDay] = useState([]);
  const [depotDropDownHTML, setDepotDropDownHTML] = useState([]);
  const [routeAttributeDropDownHTML, setRouteAttributeDropDownHTML] = useState([]);
  const [receivingAffiliatesDropDownHTML, setReceivingAffiliatesDropDownHTML] = useState([]);
  const [depotSelected, setDepotSelected] = useState(0);
  const [depotSelectedForDay, setDepotSelectedForDay] = useState(0);
  const [routeAttribute, setSelectedRouteAttribute] = useState([]);
  const [receivingAffiliates, setSelectedReceivingAffiliates] = useState(0);
  const [updateTypeChecked, setUpdateTypeChecked] = useState(0);
  // const [breakStartTimeVal, setBreakStartTimeVal] = useState(["0:00"]);
  const [startTime, setStartTime] = useState('');
  const [startTimeSelectedForDay, setStartTimeSelectedForDay] = useState('');
  const [RouteID, setRouteID] = useState('');
  const [RouteIDSelectedForDay, setRouteIDSelectedForDay] = useState('');
  const [activeVehCheck, setActiveVehCheck] = useState(false);
  const [activeVehCheckSelectedForDay, setActiveVehCheckSelectedForDay] = useState(false);
  const xCancelSourceForGrid = useRef(null);
  const vehDataRef = useRef([]);
  const [modalBodyHTML, setModalBodyHTML] = useState("");
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [modalBtnHTML, setModalBtnHTML] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedAttributes, setSelectedAttributes] = useState([])
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [confirmationModalObj, setConfirmationModalObj] = useState({
    show: false, title: 'Delete Route',
    body: 'Are you sure, you want to permanently delete this route from Manifest Setting?', btnCanceText: 'No',
    btnOkText: 'Yes'
  });

  useEffect(() => {
    try {
      vehDataRef.current = [];
      handleGetRouteSettings();
      let startDate = new Date(props?.data?.dtRouteStartTime);
      let endDate = new Date(props?.data?.dtRouteEndTime);
      let duration = (endDate - startDate);
      if (props.data?.SelectedForTheDay == 0) {
        setUpdateTypeChecked(parseInt(2));
      } else {
        setUpdateTypeChecked(parseInt(props.data?.SelectedForTheDay));
      }

      if (props.data?.RouteStatus?.toUpperCase() === "ACTIVE" || props.data?.RouteStatus?.toUpperCase() === "ASSIGNED" || props.data?.RouteStatus?.toUpperCase() === "TRANSFERRED") {
        setActiveVehCheck(true);
        setActiveVehCheckSelectedForDay(true);
      }
      else {
        setActiveVehCheck(false);
        setActiveVehCheckSelectedForDay(false);
      }

      const PerAffiliateVehTypesFilter = VehicleTypesPerAffiliateData?.filter(vehicle => vehicle?.iVTypeATSPID === parseInt(props?.data?.iAffiliateID)).map(vehicle => vehicle?.vName);

      let vehData = DispatchVehicleData[props?.data?.iAffiliateID] !== "" ? DispatchVehicleData[props?.data?.iAffiliateID] : "[]";
      let tempArray = JSON.parse(vehData);
      const newObject = {
        "VehicleNumber": " ", "VehicleID": -1, "VehicleType": "Select", "DriverNumber": "",
        "DriverID": -1, "DriverName": ",", "RowNumber": 46, "iAffID": 28, "STATE": "", "iVTypeID": 3,
        "VehicleNoANDRank": "-1", "MaxWheelChairs": 2, "TotalCapacity": 16, "LessPerWheelChair": 0.00
      };
      tempArray.unshift(newObject);
      const updatedJSON = JSON.stringify(tempArray);
      vehDataRef.current = JSON.parse(updatedJSON);
      vehDataRef.current = handleDuplicates(JSON.parse(updatedJSON), "VehicleNumber");
      let vehDropDown = handleDuplicates(JSON.parse(updatedJSON), "VehicleType");
      let vehicleNumOptionsHTML = vehDataRef?.current?.map(function (item, index) {
        return (
          <option key={index} value={item.VehicleID}>{item.VehicleNumber}</option>
        );
      });

      let vehicleTypeOptionsHTML = PerAffiliateVehTypesFilter?.map((type, index) => {
        if (type && type.toUpperCase() !== "TESTTYPE") {
          return (
            <option key={index} value={type}>{type}</option>
          );
        }
      });

      setVehOptionsManageHTML(vehicleNumOptionsHTML);
      setVehTypeOptionsManageHTML(vehicleTypeOptionsHTML);
      props?.data?.vName !== undefined && props?.data?.vName !== "" ? setVehType(props?.data?.vName) : setVehType("N/A");
      setVehNum(String(props?.data?.iVehicleID))
      setVehNumSelectedForDay(String(props?.data?.iVehicleID))
    }
    catch (err) { console.log(err); }

  }, []);

  const handleCloseModal = () => {
    setShowDynamicModal(false);
    props.setInvokeEditRouteSettings(false);
  };

  const handleDuplicates = (dict, title) => {
    try {
      let newArray = [];
      let uniqueObject = {};

      for (var j in dict) {
        let objTitle = dict[j][title];
        uniqueObject[objTitle] = dict[j];
      }
      for (var u in uniqueObject) {
        newArray.push(uniqueObject[u]);
      }
      return newArray;
    }
    catch (err) { console.log(err); }
  };

  const handleGetRouteSettings = async () => {
    try {
      let a = props?.SelectedDate?.split('-');
      let year = a[0];
      let day = a[2];
      let month = a[1];

      let manifestNumber = year + month + day + props.data?.vVirtualRoute;

      let editData = {
        "route": props.data?.vVirtualRoute,
        "dtSelectedDate": props?.data?.dtRouteStartTime?.split("T")[0],
        "iSettingID": parseInt(props?.data?.iSettingID),
        "iAffilaiteID": parseInt(props?.affiliate),
        "vManifestNumber": (props?.data?.vManifestNumber) ? props?.data?.vManifestNumber : manifestNumber,
        "iRouteID": parseInt(props?.data?.iRouteID)
      };

      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteSettings", "post", {}, editData, xCancelSourceForGrid.current);
      setSelectedAttributes(response?.data?.SelectedAttribute)
      const preselectedOptions = response?.data?.SelectedAttribute?.map(attr => String(attr?.iAttributeID));
      setSelectedOptions(preselectedOptions);
      let result = response?.data;
      if (result && result?.RouteDetail?.length > 0) {
        let routeDetailSelectedForDay = result?.RouteDetail?.find(item => parseInt(item.SelectedForTheDay) == props?.data?.SelectedForTheDay);
        let routeDetail = result?.RouteDetail[(result?.RouteDetail?.length - 1)];
        setFileNameSelectedForDay(routeDetailSelectedForDay?.vSettingsName === null || routeDetailSelectedForDay?.vSettingsName === "" ? "[Default File Name]" : routeDetailSelectedForDay?.vSettingsName);
        setVehNumSelectedForDay((String(routeDetailSelectedForDay?.iVehicleID) !== "-1" ? routeDetailSelectedForDay?.iVehicleID : "-1"));
        if (routeDetailSelectedForDay?.vehTypeName){
          setVehTypeSelectedForDay(String(routeDetailSelectedForDay?.vehTypeName) !== null ? String(routeDetailSelectedForDay?.vehTypeName) : "N/A");
        }
        else{
          setVehTypeSelectedForDay(String(routeDetail?.vehTypeName) !== null ? String(routeDetail?.vehTypeName) : "N/A");
        }
        setDurationSelectedForDay(routeDetailSelectedForDay?.MaxRouteHours);
        setStartTimeSelectedForDay(routeDetailSelectedForDay?.dtRouteStartTime?.split("T")[1]);
        setRouteIDSelectedForDay(routeDetailSelectedForDay?.RouteID);
        setFileName(routeDetail?.vSettingsName === null || routeDetail?.vSettingsName === "" ? "[Default File Name]" : routeDetail?.vSettingsName);
        setVehNum((String(routeDetail?.iVehicleID) !== "-1" ? routeDetail?.iVehicleID : "-1"));
        setVehType(String(routeDetail?.vehTypeName) !== null ? String(routeDetail?.vehTypeName) : "N/A");
        setDuration(routeDetail?.MaxRouteHours);
        setStartTime(routeDetail?.dtRouteStartTime.split("T")[1]);
        setRouteID(routeDetail?.RouteID);
        setDepotSelected(routeDetail?.iDepot);
        setDepotSelectedForDay(routeDetailSelectedForDay?.iDepot);
        if (result?.Break && result?.Break?.length > 0) {
          let IDArrForTheDay = [];
          let IDArr = [];
          let breakTimeInfo = [];
          let breakTimeInfoForTheDay = [];
          for (let j = 0; j < result?.Break?.length; j++) {
            if (result?.Break[j]?.SelectedForTheDay == 0) {
              IDArr.push(result?.Break[j]?.ID);
              breakTimeInfo?.push({
                iID: result?.Break[j]?.ID, startTime: result?.Break[j]?.BreakStartTime?.split("T")[1], startHour: result?.Break[j]?.HoursfromRouteStartTime,
                earlyWindow: result?.Break[j]?.BreakEarlyWindow, lateWindow: result?.Break[j]?.BreakLateWindow, duration: result?.Break[j]?.BreakDuration
              });
            }
            else {
              IDArrForTheDay.push(result?.Break[j]?.ID);
              breakTimeInfoForTheDay?.push({
                iID: result?.Break[j]?.ID, startTime: result?.Break[j]?.BreakStartTime?.split("T")[1], startHour: result?.Break[j]?.HoursfromRouteStartTime,
                earlyWindow: result?.Break[j]?.BreakEarlyWindow, lateWindow: result?.Break[j]?.BreakLateWindow, duration: result?.Break[j]?.BreakDuration
              });
            }
          }
          setBreakTimeRowsSelectedForDay(IDArrForTheDay);
          setBreakTimeRowInfoSelectedForDay(breakTimeInfoForTheDay);
          setBreakTimeRows(IDArr);
          setBreakTimeRowInfo(breakTimeInfo);
        }
        setActiveVehCheck(routeDetail?.isActive ? routeDetail?.isActive : false);
        setActiveVehCheckSelectedForDay(routeDetailSelectedForDay?.isActive ? routeDetailSelectedForDay?.isActive : false);
      }
      else {
        setFileName("[Default File Name]");
        setVehNum(0);
        setVehNumSelectedForDay(0)
      }
      if (result && result?.Depot && result.Depot?.length > 0) {
        const newObject = {
          "DepotNumber": 0,
          "DepotName": " ",
          "DepotAddress": "",
          "DepotLatitude": "",
          "DepotLongitude": "",
          "vSettingsName": "",
          "bIsHoldingLot": true,
          "vDepotZone": "",
          "iSettingID": -1,
          "vDepotCity": "",
          "vDepotState": "",
          "vDepotZip": ""
        };
        result?.Depot?.unshift(newObject);
        let depotComponentHTML = result?.Depot?.map(function (item, index) {
          return (
            <option key={index} value={item.DepotNumber}>{item.DepotName}</option>
          );
        });
        setDepotDropDownHTML(depotComponentHTML);
      }
      else {
        let currentDepotSelection = [0];
        let depotComponentHTML = currentDepotSelection?.map(function (item, index) {
          return (
            <option key={index} value={item}>{"Default Depot"}</option>
          );
        });
        setDepotDropDownHTML(depotComponentHTML);
      }

      if (result && result?.Attribute && result?.Attribute?.length > 0) {
        setSelectedRouteAttribute(result?.SelectedAttribute[0]?.iAttributeID ? result?.SelectedAttribute[0]?.iAttributeID : "-1");
        let attributeComponentHTML = result?.Attribute?.map(function (item, index) {
          return (
            <option key={index} value={item.iID}>{item.vTitle}</option>
          );
        });
        setRouteAttributeDropDownHTML(attributeComponentHTML);
      }
      else {
        let currentSelection = [0];
        let attributeComponentHTML = currentSelection.map(function (item, index) {
        });
        setRouteAttributeDropDownHTML(attributeComponentHTML);
      }

      if (result && result?.TransferingAffiliates && result?.TransferingAffiliates?.length > 0) {
        setSelectedReceivingAffiliates(result?.SelectedTransferingAffilaite[0]?.iServingAffiliateID ? result?.SelectedTransferingAffilaite[0]?.iServingAffiliateID : "-1");
        let affiliateComponentHTML = result?.TransferingAffiliates?.map(function (item, index) {
          return (
            <option key={index} value={item.iAffiliateID}>{item.vName}</option>
          );
        });

        affiliateComponentHTML?.unshift(
          <option key="default" value="-1">Select Affiliate</option>
        );

        setReceivingAffiliatesDropDownHTML(affiliateComponentHTML);
      }
      else {
        let currentSelection = [0];
        let affiliateComponentHTML = currentSelection?.map(function (item, index) {
          return (
            <option key={index} value={item}>{"Select Affiliate"}</option>
          );
        });
        setReceivingAffiliatesDropDownHTML(affiliateComponentHTML);
      }

    }
    catch (err) { console.log(err); }
  };

  const handleAddRow = () => {
    try {
      if (breakTimeRows?.length === 0) {
        setBreakTimeRows([...breakTimeRows, "newBreakTime" + 1]);
        setBreakTimeRowInfo([...breakTimeRowInfo, { startTime: "", startHour: "", earlyWindow: "", lateWindow: "", duration: "" }]);
      }
      else {
        setBreakTimeRows([...breakTimeRows, "newBreakTime" + (breakTimeRows.length + 1)]);
        setBreakTimeRowInfo([...breakTimeRowInfo, { startTime: "", startHour: "", earlyWindow: "", lateWindow: "", duration: "" }]);
      }

    }
    catch (err) { console.log(err); }
  }

  const handleAddRowSelectedForDay = () => {
    try {
      if (breakTimeRowsSelectedForDay?.length === 0) {
        setBreakTimeRowsSelectedForDay([...breakTimeRowsSelectedForDay, "newBreakTime" + 1]);
        setBreakTimeRowInfoSelectedForDay([...breakTimeRowInfoSelectedForDay, { startTime: "", startHour: "", earlyWindow: "", lateWindow: "", duration: "" }]);
      }
      else {
        setBreakTimeRowsSelectedForDay([...breakTimeRowsSelectedForDay, "newBreakTime" + (breakTimeRows.length + 1)]);
        setBreakTimeRowInfoSelectedForDay([...breakTimeRowInfoSelectedForDay, { startTime: "", startHour: "", earlyWindow: "", lateWindow: "", duration: "" }]);
      }

    }
    catch (err) { console.log(err); }
  }

  const handleRemoveRow = (e) => {
    try {
      let indexToRemove = parseInt(e.target?.dataset?.virtual);
      const updatedArr = breakTimeRows?.filter((s, i) => i !== indexToRemove);
      const updatedRowInfoArr = breakTimeRowInfo?.filter((s, i) => i !== indexToRemove);
      setBreakTimeRows(updatedArr);
      setBreakTimeRowInfo(updatedRowInfoArr);
    }
    catch (err) { console.log(err); }
  };

  const handleStartTimeClear = (e) => {
    try {
      let indexToRemove = parseInt(e.target.dataset.virtual);
      const newArr = [...breakTimeRowInfo];
      newArr[indexToRemove].startTime = "";
      setBreakTimeRowInfo(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleStartTimeClearSelectedForDay = (e) => {
    try {
      let indexToRemove = parseInt(e?.target?.dataset?.virtual);
      const newArr = [...breakTimeRowInfoSelectedForDay];
      newArr[indexToRemove].startTime = "";
      setBreakTimeRowInfoSelectedForDay(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleRemoveRowSelectedForDay = (e) => {
    try {
      let indexToRemove = parseInt(e.target?.dataset?.virtual);
      const updatedArr = breakTimeRowsSelectedForDay?.filter((s, i) => i !== indexToRemove);
      const updatedRowInfoArr = breakTimeRowInfoSelectedForDay?.filter((s, i) => i !== indexToRemove);
      setBreakTimeRowsSelectedForDay(updatedArr);
      setBreakTimeRowInfoSelectedForDay(updatedRowInfoArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakStartTimeChange = (e) => {
    try {
      const newArr = [...breakTimeRowInfo];
      newArr[e.target?.dataset?.virtual].startTime = e.target?.value;
      setBreakTimeRowInfo(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakStartTimeChangeSelectedForDay = (e) => {
    try {
      const newArr = [...breakTimeRowInfoSelectedForDay];
      newArr[e.target?.dataset?.virtual].startTime = e?.target?.value;
      setBreakTimeRowInfoSelectedForDay(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakEarlyWinChange = (e) => {
    try {
      const newArr = [...breakTimeRowInfo];
      newArr[e.target?.dataset?.virtual].earlyWindow = e.target.value;
      setBreakTimeRowInfo(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakEarlyWinChangeSelectedForDay = (e) => {
    try {
      const newArr = [...breakTimeRowInfoSelectedForDay];
      newArr[e.target?.dataset?.virtual].earlyWindow = e?.target?.value;
      setBreakTimeRowInfoSelectedForDay(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakStartHourChange = (e) => {
    try {
      const newArr = [...breakTimeRowInfo];
      newArr[e.target?.dataset?.virtual].startHour = e?.target?.value;
      setBreakTimeRowInfo(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakStartHourChangeSelectedForDay = (e) => {
    try {
      const newArr = [...breakTimeRowInfoSelectedForDay];
      newArr[e.target?.dataset?.virtual].startHour = e?.target?.value;
      setBreakTimeRowInfoSelectedForDay(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakLateWinChange = (e) => {
    try {
      const newArr = [...breakTimeRowInfo];
      newArr[e.target?.dataset?.virtual].lateWindow = e?.target?.value;
      setBreakTimeRowInfo(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakLateWinChangeSelectedForDay = (e) => {
    try {
      const newArr = [...breakTimeRowInfoSelectedForDay];
      newArr[e.target.dataset.virtual].lateWindow = e?.target?.value;
      setBreakTimeRowInfoSelectedForDay(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakDurationChange = (e) => {
    try {
      const newArr = [...breakTimeRowInfo];
      newArr[e.target?.dataset?.virtual].duration = e?.target?.value;
      setBreakTimeRowInfo(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateBreakDurationChangeSelectedForDay = (e) => {
    try {
      const newArr = [...breakTimeRowInfoSelectedForDay];
      newArr[e.target?.dataset?.virtual].duration = e?.target?.value;
      setBreakTimeRowInfoSelectedForDay(newArr);
    }
    catch (err) { console.log(err); }
  };

  const handleChangeVehType = (e) => {
    try {
      setVehType(e?.target?.value);
      if (e?.target?.value === "Select") {
        setVehNum("-1_Select");
      }
    }
    catch (err) { console.log(err); }
  };

  const handleChangeVehTypeSelectedForDay = (e) => {
    try {
      setVehTypeSelectedForDay(e.target.value);
      if (e?.target?.value === "Select") {
        setVehNumSelectedForDay("-1_Select");
      }
    }
    catch (err) { console.log(err); }
  };

  const handleChangeVehNum = (e) => {
    try {
      setVehNum(e?.target?.value);
      let vehicleTypeVar = (vehDataRef?.current?.find(item => parseInt(item.VehicleID) == parseInt(e?.target?.value?.split("_")[0])));
      setVehType(vehicleTypeVar?.VehicleType);
    }
    catch (err) { console.log(err); }
  };

  const handleChangeVehNumSelectedForDay = (e) => {
    try {
      setVehNumSelectedForDay(e?.target?.value);
      let vehicleTypeVar = (vehDataRef?.current?.find(item => parseInt(item.VehicleID) == parseInt(e?.target?.value.split("_")[0])));
      setVehTypeSelectedForDay(vehicleTypeVar?.VehicleType);
    }
    catch (err) { console.log(err); }
  };

  const handleUpdateRouteSettings = async (type) => {
    let forTheDay = 0
    const commaSeparatedString = selectedOptions?.join(',');
    if (type === "defaultsetup") {
      forTheDay = 2
      try {

        let downloadRouteFooterBtns = ["OK"];
        let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function (item, index) {
          return (
            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
              {item}
            </Button>
          );
        });

        let a = props?.SelectedDate?.split('-');
        var year = a[0];
        var month = a[1]?.padStart(2, '0');
        var day = a[2]?.padStart(2, '0');

        var manifestNumber = year + month + day + props?.data?.vVirtualRoute;

        let bRecords = false;
        for (let i = 0; i < breakTimeRowInfoSelectedForDay?.length; i++) {
          if (i == 0) {
            bRecords = true;
          }
          else {
            bRecords = false;
          }
          let hrsFromRouteStartTime = breakTimeRowInfoSelectedForDay[i]?.startHour;
          let breakStartTime = breakTimeRowInfoSelectedForDay[i]?.startTime;
          let breakLateWindow = breakTimeRowInfoSelectedForDay[i]?.lateWindow;
          let breakEarlyWindow = breakTimeRowInfoSelectedForDay[i]?.earlyWindow;
          let breakDuration = breakTimeRowInfoSelectedForDay[i]?.duration;
          let iID = breakTimeRowInfoSelectedForDay[i]?.iID;
          let value = breakTimeRowInfoSelectedForDay[i]?.iID;

          // if (value > 0) {
          //     setModalHeaderText("Update Break");
          //     setModalBodyHTML("Action not allowed for a made Route. Please first un route all trips");
          //     setModalBtnHTML(downloadRouteFooterHTML); 
          //     setShowModal(true);
          //     return false;
          // }
          if (parseFloat(hrsFromRouteStartTime < 0)) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakLateWindow < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakEarlyWindow < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakDuration < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (parseFloat(hrsFromRouteStartTime) > 0 && breakStartTime != '') {
            setModalHeaderText("Update Break");
            setModalBodyHTML("You can update only Break Start Time or Hrs From Route Break Time!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (hrsFromRouteStartTime == '' && breakStartTime == '') {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Both Break Start Time or Hrs From Route Break Time should not be Empty");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }

          for (let j = i + 1; j < breakTimeRowInfoSelectedForDay?.length; j++) {
            let hrsFromRouteStartTime = breakTimeRowInfoSelectedForDay[i]?.startHour;
            let breakStartTime = breakTimeRowInfoSelectedForDay[i]?.startTime;
            let breakLateWindow = breakTimeRowInfoSelectedForDay[i]?.lateWindow;
            let breakEarlyWindow = breakTimeRowInfoSelectedForDay[i]?.earlyWindow;
            let breakDuration = breakTimeRowInfoSelectedForDay[i]?.duration;
            let iID = breakTimeRowInfoSelectedForDay[i]?.iID;
            if (parseFloat(hrsFromRouteStartTime) > 0) {
              if (hrsFromRouteStartTime == breakTimeRowInfoSelectedForDay[j]?.startHour) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Route Start Time");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime) {
              if (breakStartTime == breakTimeRowInfoSelectedForDay[j]?.startTime) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.startTime != "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can updated either Break Start Time or Hrs from Route Start");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (hrsFromRouteStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.startHour != "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can updated either Break Start Time or Hrs from Route Start");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (parseFloat(hrsFromRouteStartTime) > 0) {
              let startRouteTime = parseFloat(hrsFromRouteStartTime) * 60;
              let endRouteTime = parseFloat(hrsFromRouteStartTime) * 60 + parseFloat(breakDuration);

              let startRouteTime1 = (parseFloat(breakTimeRowInfoSelectedForDay[j]?.startHour) * 60);
              let endRouteTime1 = (parseFloat(breakTimeRowInfoSelectedForDay[j]?.startHour) * 60) + parseFloat(breakTimeRowInfoSelectedForDay[j]?.duration);
              if (startRouteTime < endRouteTime1 && endRouteTime >= startRouteTime1) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.startHour == "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can update either Break Start Time or Hrs From Route Break Time!!!!");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (hrsFromRouteStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.duration == "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can update either Break Start Time or Hrs From Route Break Time!!!!");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (breakStartTime) {
              let dat = new Date();
              let year = dat.getFullYear();
              let month = dat.getMonth();
              let day = dat.getDate();

              let getMinutes = 0;
              let getHour = 0;
              try {
                getMinutes = breakStartTime?.split(':')[1];
                getHour = breakStartTime?.split(':')[0];
              } catch { }

              let getSeconds = breakStartTime?.split(':')[2];
              try {
                if (typeof (breakStartTime?.split(':')[2]) == 'undefined') {
                  getSeconds = 0;
                }
                else {
                  getSeconds = breakStartTime?.split(':')[2];
                }

              } catch { }
              let startTime = new Date(year, month, day, getHour, parseInt(getMinutes), getSeconds);
              let endTime = new Date(year, month, day, getHour, parseInt(getMinutes) + parseInt(breakDuration), getSeconds);

              let breakStartTime1 = breakTimeRowInfoSelectedForDay[j]?.startTime;
              let breakDuration1 = breakTimeRowInfoSelectedForDay[j]?.duration;
              let getMinutes1 = 0;
              let getHour1 = 0;
              try {
                getMinutes1 = breakStartTime1?.split(':')[1];
                getHour1 = breakStartTime1?.split(':')[0];
              } catch { }

              let getSeconds1 = 0;
              try {
                if (typeof (breakStartTime1?.split(':')[2]) == 'undefined') {
                  getSeconds1 = 0;
                }
                else {
                  getSeconds1 = breakStartTime1?.split(':')[2];
                }

              } catch { }

              let startTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1), getSeconds1);
              let endTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1) + parseInt(breakDuration1), getSeconds1);
              if (startTime < endTime1 && endTime > startTime1) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
          }
          let InputData = {
            "iID": iID,
            "hrsFromRouteStartTime": hrsFromRouteStartTime,
            "breakStartTime": breakStartTime,
            "breakEarlyWindow": breakEarlyWindow,
            "breakLateWindow": breakLateWindow,
            "breakDuration": breakDuration,
            "bRecords": bRecords,
            "iSettingID": props.data.iSettingID,
            "vManifestNumber": manifestNumber,
            "updateSelection": forTheDay

          };
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateBreakTimes", "post", {}, InputData, xCancelSourceForGrid.current);
          let result = response.data;
          if (result[0].Failed == "AlreadyMade") {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Route is already Assigned, Please UnAssigned the Route to Insert the Break!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          else if (result.Passed == "true") {

          }
        }

        if (breakTimeRowInfoSelectedForDay?.length == 0) {
          let params = {
            "iSettingID": props.data.iSettingID,
            "UpdateSelection": forTheDay,
            "vManifestNumber": manifestNumber,
          }
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/RemoveSingleBreak", "post", {}, params, xCancelSourceForGrid.current);
          let result = response?.data;
          if (result[0]?.Passed == "true") {
          }
        }

        let params = {
          "vSettingName": props.data.vSettingName,
          "dtSelectedDate": props.SelectedDate,
          "vRoute": props.data.vVirtualRoute,
          "vVehNum": String(vehNumSelectedForDay),
          "vDepotNum": String(depotSelectedForDay),
          "ManifestSettings": false,
          "vVehicleType": vehTypeSelectedForDay,
          "bActiveInAvtiveVeh": activeVehCheckSelectedForDay,
          "bUpdateActiveInActiveVehFromCshkBox": false,
          "RouteDuration": DurationSelectedForDay,
          "RouteStartTime": startTimeSelectedForDay,
          "iSettingID": props.data.iSettingID,
          "iRouteID": RouteIDSelectedForDay,
          "attributeID": commaSeparatedString,
          "receivingAffiliateID": parseInt(receivingAffiliates)

        }

        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateRouteInfo", "post", {}, params, xCancelSourceForGrid.current);
        let result = response?.data;
        if (result[0]?.Passed == "true") {
          setModalHeaderText("Update Route");
          setModalBodyHTML("Route is saved Successfully!!!");
          setModalBtnHTML(downloadRouteFooterHTML);
          setShowModal(true);
          return false;
        }

      }
      catch (err) { console.log(err); }
    }

    if (type === "selectedDay") {
      forTheDay = 1
      try {

        let downloadRouteFooterBtns = ["OK"];
        let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function (item, index) {
          return (
            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
              {item}
            </Button>
          );
        });

        let a = props.SelectedDate?.split('-');
        var year = a[0];
        var month = a[1]?.padStart(2, '0');
        var day = a[2]?.padStart(2, '0');
        var manifestNumber = year + month + day + props?.data?.vVirtualRoute;

        let bRecords = false;
        for (let i = 0; i < breakTimeRowInfoSelectedForDay?.length; i++) {
          if (i == 0) {
            bRecords = true;
          }
          else {
            bRecords = false;
          }
          let hrsFromRouteStartTime = breakTimeRowInfoSelectedForDay[i]?.startHour;
          let breakStartTime = breakTimeRowInfoSelectedForDay[i]?.startTime;
          let breakLateWindow = breakTimeRowInfoSelectedForDay[i]?.lateWindow;
          let breakEarlyWindow = breakTimeRowInfoSelectedForDay[i]?.earlyWindow;
          let breakDuration = breakTimeRowInfoSelectedForDay[i]?.duration;
          let iID = breakTimeRowInfoSelectedForDay[i]?.iID;
          let value = breakTimeRowInfoSelectedForDay[i]?.iID;

          // if (value > 0) {
          //     setModalHeaderText("Update Break");
          //     setModalBodyHTML("Action not allowed for a made Route. Please first un route all trips");
          //     setModalBtnHTML(downloadRouteFooterHTML); 
          //     setShowModal(true);
          //     return false;
          // }
          if (parseFloat(hrsFromRouteStartTime < 0)) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakLateWindow < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakEarlyWindow < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakDuration < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (parseFloat(hrsFromRouteStartTime) > 0 && breakStartTime != '') {
            setModalHeaderText("Update Break");
            setModalBodyHTML("You can update only Break Start Time or Hrs From Route Break Time!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (hrsFromRouteStartTime == '' && breakStartTime == '') {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Both Break Start Time or Hrs From Route Break Time should not be Empty");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }

          for (let j = i + 1; j < breakTimeRowInfoSelectedForDay?.length; j++) {
            let hrsFromRouteStartTime = breakTimeRowInfoSelectedForDay[i]?.startHour;
            let breakStartTime = breakTimeRowInfoSelectedForDay[i]?.startTime;
            let breakLateWindow = breakTimeRowInfoSelectedForDay[i]?.lateWindow;
            let breakEarlyWindow = breakTimeRowInfoSelectedForDay[i]?.earlyWindow;
            let breakDuration = breakTimeRowInfoSelectedForDay[i]?.duration;
            let iID = breakTimeRowInfoSelectedForDay[i]?.iID;
            if (parseFloat(hrsFromRouteStartTime) > 0) {
              if (hrsFromRouteStartTime == breakTimeRowInfoSelectedForDay[j]?.startHour) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Route Start Time");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime) {
              if (breakStartTime == breakTimeRowInfoSelectedForDay[j]?.startTime) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.startTime != "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can updated either Break Start Time or Hrs from Route Start");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (hrsFromRouteStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.startHour != "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can updated either Break Start Time or Hrs from Route Start");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (parseFloat(hrsFromRouteStartTime) > 0) {
              let startRouteTime = parseFloat(hrsFromRouteStartTime) * 60;
              let endRouteTime = parseFloat(hrsFromRouteStartTime) * 60 + parseFloat(breakDuration);

              let startRouteTime1 = (parseFloat(breakTimeRowInfoSelectedForDay[j]?.startHour) * 60);
              let endRouteTime1 = (parseFloat(breakTimeRowInfoSelectedForDay[j]?.startHour) * 60) + parseFloat(breakTimeRowInfoSelectedForDay[j]?.duration);
              if (startRouteTime < endRouteTime1 && endRouteTime >= startRouteTime1) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.startHour == "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can update either Break Start Time or Hrs From Route Break Time!!!!");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (hrsFromRouteStartTime == "" && breakTimeRowInfoSelectedForDay[j]?.duration == "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can update either Break Start Time or Hrs From Route Break Time!!!!");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (breakStartTime) {
              let dat = new Date();
              let year = dat?.getFullYear();
              let month = dat?.getMonth();
              let day = dat?.getDate();

              let getMinutes = 0;
              let getHour = 0;
              try {
                getMinutes = breakStartTime?.split(':')[1];
                getHour = breakStartTime?.split(':')[0];
              } catch { }

              let getSeconds = breakStartTime?.split(':')[2];
              try {
                if (typeof (breakStartTime?.split(':')[2]) == 'undefined') {
                  getSeconds = 0;
                }
                else {
                  getSeconds = breakStartTime?.split(':')[2];
                }

              } catch { }
              let startTime = new Date(year, month, day, getHour, parseInt(getMinutes), getSeconds);
              let endTime = new Date(year, month, day, getHour, parseInt(getMinutes) + parseInt(breakDuration), getSeconds);

              let breakStartTime1 = breakTimeRowInfoSelectedForDay[j]?.startTime;
              let breakDuration1 = breakTimeRowInfoSelectedForDay[j]?.duration;
              let getMinutes1 = 0;
              let getHour1 = 0;
              try {
                getMinutes1 = breakStartTime1?.split(':')[1];
                getHour1 = breakStartTime1?.split(':')[0];
              } catch { }

              let getSeconds1 = 0;
              try {
                if (typeof (breakStartTime1?.split(':')[2]) == 'undefined') {
                  getSeconds1 = 0;
                }
                else {
                  getSeconds1 = breakStartTime1?.split(':')[2];
                }

              } catch { }

              let startTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1), getSeconds1);
              let endTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1) + parseInt(breakDuration1), getSeconds1);
              if (startTime < endTime1 && endTime > startTime1) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
          }
          let InputData = {
            "iID": iID,
            "hrsFromRouteStartTime": hrsFromRouteStartTime,
            "breakStartTime": breakStartTime,
            "breakEarlyWindow": breakEarlyWindow,
            "breakLateWindow": breakLateWindow,
            "breakDuration": breakDuration,
            "bRecords": bRecords,
            "iSettingID": props.data.iSettingID,
            "vManifestNumber": manifestNumber,
            "updateSelection": forTheDay

          };
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateBreakTimes", "post", {}, InputData, xCancelSourceForGrid.current);
          let result = response?.data;
          if (result[0]?.Failed == "AlreadyMade") {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Route is already Assigned, Please UnAssigned the Route to Insert the Break!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          else if (result.Passed == "true") {

          }
        }

        if (breakTimeRowInfoSelectedForDay?.length == 0) {
          let params = {
            "iSettingID": props?.data?.iSettingID,
            "UpdateSelection": forTheDay,
            "vManifestNumber": manifestNumber,
          }
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/RemoveSingleBreak", "post", {}, params, xCancelSourceForGrid.current);
          let result = response.data;
          if (result[0].Passed == "true") {
          }
        }

        let params = {
          "vSettingName": props?.data?.vSettingName,
          "dtSelectedDate": props?.SelectedDate,
          "vRoute": props?.data?.vVirtualRoute,
          "vVehNum": String(vehNumSelectedForDay),
          "vDepotNum": String(depotSelectedForDay),
          "ManifestSettings": true,
          "vVehicleType": vehTypeSelectedForDay,
          "bActiveInAvtiveVeh": activeVehCheckSelectedForDay,
          "bUpdateActiveInActiveVehFromCshkBox": false,
          "RouteDuration": DurationSelectedForDay,
          "RouteStartTime": startTimeSelectedForDay,
          "iSettingID": props?.data?.iSettingID,
          "iRouteID": 0, //RouteIDSelectedForDay,
          "attributeID": commaSeparatedString,
          "receivingAffiliateID": parseInt(receivingAffiliates)

        }

        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateRouteInfo", "post", {}, params, xCancelSourceForGrid.current);
        let result = response?.data;
        if (result[0]?.Passed == "true") {
          setModalHeaderText("Update Route");
          setModalBodyHTML("Route is saved Successfully!!!");
          setModalBtnHTML(downloadRouteFooterHTML);
          setShowModal(true);
          return false;
        }

      }
      catch (err) { console.log(err); }
    }
    else {
      forTheDay = 2
      try {

        let downloadRouteFooterBtns = ["OK"];
        let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function (item, index) {
          return (
            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
              {item}
            </Button>
          );
        });

        let a = props?.SelectedDate?.split('-');
        var year = a[0];
        var month = a[1]?.padStart(2, '0');
        var day = a[2]?.padStart(2, '0');
        var manifestNumber = year + month + day + props?.data?.vVirtualRoute;

        let bRecords = false;
        for (let i = 0; i < breakTimeRowInfo?.length; i++) {
          if (i == 0) {
            bRecords = true;
          }
          else {
            bRecords = false;
          }
          let hrsFromRouteStartTime = breakTimeRowInfo[i]?.startHour;
          let breakStartTime = breakTimeRowInfo[i]?.startTime;
          let breakLateWindow = breakTimeRowInfo[i]?.lateWindow;
          let breakEarlyWindow = breakTimeRowInfo[i]?.earlyWindow;
          let breakDuration = breakTimeRowInfo[i]?.duration;
          let iID = breakTimeRowInfo[i]?.iID;
          let value = breakTimeRowInfo[i]?.iID;

          // if (value > 0) {
          //     setModalHeaderText("Update Break");
          //     setModalBodyHTML("Action not allowed for a made Route. Please first un route all trips");
          //     setModalBtnHTML(downloadRouteFooterHTML); 
          //     setShowModal(true);
          //     return false;
          // }
          if (parseFloat(hrsFromRouteStartTime < 0)) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakLateWindow < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakEarlyWindow < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (breakDuration < 0) {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Value should be greater than zero!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (parseFloat(hrsFromRouteStartTime) > 0 && breakStartTime != '') {
            setModalHeaderText("Update Break");
            setModalBodyHTML("You can update only Break Start Time or Hrs From Route Break Time!!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          if (hrsFromRouteStartTime == '' && breakStartTime == '') {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Both Break Start Time or Hrs From Route Break Time should not be Empty");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }

          for (let j = i + 1; j < breakTimeRowInfo?.length; j++) {
            let hrsFromRouteStartTime = breakTimeRowInfo[i]?.startHour;
            let breakStartTime = breakTimeRowInfo[i]?.startTime;
            let breakLateWindow = breakTimeRowInfo[i]?.lateWindow;
            let breakEarlyWindow = breakTimeRowInfo[i]?.earlyWindow;
            let breakDuration = breakTimeRowInfo[i]?.duration;
            let iID = breakTimeRowInfo[i]?.iID;
            if (parseFloat(hrsFromRouteStartTime) > 0) {
              if (hrsFromRouteStartTime == breakTimeRowInfo[j]?.startHour) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Route Start Time");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime) {
              if (breakStartTime == breakTimeRowInfo[j]?.startTime) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime == "" && breakTimeRowInfo[j]?.startTime != "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can updated either Break Start Time or Hrs from Route Start");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (hrsFromRouteStartTime == "" && breakTimeRowInfo[j]?.startHour != "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can updated either Break Start Time or Hrs from Route Start");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (parseFloat(hrsFromRouteStartTime) > 0) {
              let startRouteTime = parseFloat(hrsFromRouteStartTime) * 60;
              let endRouteTime = parseFloat(hrsFromRouteStartTime) * 60 + parseFloat(breakDuration);

              let startRouteTime1 = (parseFloat(breakTimeRowInfo[j]?.startHour) * 60);
              let endRouteTime1 = (parseFloat(breakTimeRowInfo[j]?.startHour) * 60) + parseFloat(breakTimeRowInfo[j]?.duration);
              if (startRouteTime < endRouteTime1 && endRouteTime >= startRouteTime1) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
            if (breakStartTime == "" && breakTimeRowInfo[j]?.startHour == "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can update either Break Start Time or Hrs From Route Break Time!!!!");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (hrsFromRouteStartTime == "" && breakTimeRowInfo[j]?.duration == "") {
              setModalHeaderText("Update Break");
              setModalBodyHTML("You can update either Break Start Time or Hrs From Route Break Time!!!!");
              setModalBtnHTML(downloadRouteFooterHTML);
              setShowModal(true);
              return false;
            }
            if (breakStartTime) {
              let dat = new Date();
              let year = dat?.getFullYear();
              let month = dat?.getMonth();
              let day = dat?.getDate();

              let getMinutes = 0;
              let getHour = 0;
              try {
                getMinutes = breakStartTime?.split(':')[1];
                getHour = breakStartTime?.split(':')[0];
              } catch { }

              let getSeconds = breakStartTime?.split(':')[2];
              try {
                if (typeof (breakStartTime?.split(':')[2]) == 'undefined') {
                  getSeconds = 0;
                }
                else {
                  getSeconds = breakStartTime?.split(':')[2];
                }

              } catch { }
              let startTime = new Date(year, month, day, getHour, parseInt(getMinutes), getSeconds);
              let endTime = new Date(year, month, day, getHour, parseInt(getMinutes) + parseInt(breakDuration), getSeconds);

              let breakStartTime1 = breakTimeRowInfo[j]?.startTime;
              let breakDuration1 = breakTimeRowInfo[j]?.duration;
              let getMinutes1 = 0;
              let getHour1 = 0;
              try {
                getMinutes1 = breakStartTime1?.split(':')[1];
                getHour1 = breakStartTime1?.split(':')[0];
              } catch { }

              let getSeconds1 = 0;
              try {
                if (typeof (breakStartTime1?.split(':')[2]) == 'undefined') {
                  getSeconds1 = 0;
                }
                else {
                  getSeconds1 = breakStartTime1?.split(':')[2];
                }

              } catch { }

              let startTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1), getSeconds1);
              let endTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1) + parseInt(breakDuration1), getSeconds1);
              if (startTime < endTime1 && endTime > startTime1) {
                setModalHeaderText("Update Break");
                setModalBodyHTML("Clash Between Break Start Times");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
                return false;
              }
            }
          }
          let InputData = {
            "iID": iID,
            "hrsFromRouteStartTime": hrsFromRouteStartTime,
            "breakStartTime": breakStartTime,
            "breakEarlyWindow": breakEarlyWindow,
            "breakLateWindow": breakLateWindow,
            "breakDuration": breakDuration,
            "bRecords": bRecords,
            "iSettingID": props.data.iSettingID,
            "vManifestNumber": manifestNumber,
            "updateSelection": forTheDay

          };
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateBreakTimes", "post", {}, InputData, xCancelSourceForGrid.current);
          let result = response?.data;
          if (result[0]?.Failed == "AlreadyMade") {
            setModalHeaderText("Update Break");
            setModalBodyHTML("Route is already Assigned, Please UnAssigned the Route to Insert the Break!!!");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
            return false;
          }
          else if (result.Passed == "true") {

          }
        }

        if (breakTimeRowInfo.length == 0) {
          let params = {
            "iSettingID": props?.data?.iSettingID,
            "UpdateSelection": forTheDay,
            "vManifestNumber": manifestNumber,
          }
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/RemoveSingleBreak", "post", {}, params, xCancelSourceForGrid.current);
          let result = response?.data;
          if (result[0]?.Passed == "true") {
          }
        }

        let params = {
          "vSettingName": props?.data?.vSettingName,
          "dtSelectedDate": props?.SelectedDate,
          "vRoute": props?.data?.vVirtualRoute,
          "vVehNum": String(vehNum),
          "vDepotNum": String(depotSelected),
          "ManifestSettings": false,
          "vVehicleType": vehType,
          "bActiveInAvtiveVeh": activeVehCheck,
          "bUpdateActiveInActiveVehFromCshkBox": false,
          "RouteDuration": Duration,
          "RouteStartTime": startTime,
          "iSettingID": props?.data?.iSettingID,
          "iRouteID": RouteID,
          "attributeID": commaSeparatedString,
          "receivingAffiliateID": parseInt(receivingAffiliates)

        }

        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateRouteInfo", "post", {}, params, xCancelSourceForGrid.current);
        let result = response?.data;
        if (result[0]?.Passed == "true") {
          setModalHeaderText("Update Route");
          setModalBodyHTML("Route is saved Successfully!!!");
          setModalBtnHTML(downloadRouteFooterHTML);
          setShowModal(true);
          return false;
        }

      }
      catch (err) { console.log(err); }
    }
  };

  const handleUpdateTypeChange = (e) => {
    try {
      setUpdateTypeChecked(parseInt(e.target.value));
    }
    catch (err) { console.log(err); }
  };

  const handleModalClose = () => {
    setShowModal(false);
    handleCloseModal();
  };

  const handleDeleteRoute = async () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Delete Route', body: "Are you sure, you want to permanently delete this route from Manifest Setting?", btnCanceText: 'No', btnOkText: 'Yes' }));
  }

  const handleConfirmationModalCancel = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
  }

  const handleConfirmationModalClose = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
  }

  const handleConfirmationModalOk = async () => {
    let a = props?.SelectedDate?.split('-');
    var year = a[0];
    var day = a[2];
    var month = a[1];

    var manifestNumber = year + month + day + props.data?.vVirtualRoute;
    let downloadRouteFooterBtns = ["OK"];
    let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function (item, index) {
      return (
        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
          {item}
        </Button>
      );
    });
    let params = {
      "vRoute": props?.data?.vVirtualRoute,
      "iSettingID": props?.data?.iSettingID,
      "vManifestNumber": (props?.data?.vManifestNumber) ? props?.data?.vManifestNumber : manifestNumber
    }

    xCancelSourceForGrid.current = APICom.GenerateSource();
    let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/DeleteRoute", "post", {}, params, xCancelSourceForGrid.current);
    let result = response?.data;
    if (result[0]?.Result == "true") {
      setModalHeaderText("Delete Route");
      setModalBodyHTML("Route is Successfully Deleted!!!");
      setModalBtnHTML(downloadRouteFooterHTML);
      setShowModal(true);
      setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
      //handleCloseModal();
    }
    else {
      setModalHeaderText("Delete Route");
      setModalBodyHTML("Route is not Deleted!!!");
      setModalBtnHTML(downloadRouteFooterHTML);
      setShowModal(true);
      setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
      //handleCloseModal();
    }
  }

  const handleCheckboxChange = (event, value) => {
    if (event?.target?.checked) {
      setSelectedRouteAttribute(prevAttributes => [...prevAttributes, value]);
    } else {
      setSelectedRouteAttribute(prevAttributes => prevAttributes.filter(attr => attr !== value));
    }
  };

  const handleApplyDefaultSetup = () => {
    handleUpdateRouteSettings("defaultsetup")
  }

  const handleSelect = (option) => {
    if (selectedOptions?.includes(option)) {
      setSelectedOptions(selectedOptions?.filter((item) => item !== option)); // Remove option if already selected
    } else {
      setSelectedOptions([...selectedOptions, option]); // Add option if not selected
    }
  };

  return (
    <>
      {showDynamicModal ?
        <Modal centered backdrop="static" keyboard={true} size='lg' onHide={handleCloseModal} show={showDynamicModal} animation={true}>
          <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
            <Modal.Title className='text-white user-select-none'>
              Edit Route Settings
            </Modal.Title>
          </Modal.Header>
          <div className='custom-modal'>
            <Tabs style={{ backgroundColor: "#58B6BE", borderBottom: "4px solid #B7E1E4 " }} className='px-3' defaultActiveKey="selectedDaySetup" id="route-setting-tabs">
              <Tab eventKey="selectedDaySetup" title="Selected day setup">
                <div className="p-4">
                  <Row className='w-100'>
                    <Col>
                      <p className='m-0 mx-1 user-select-none'>Selected File Name:</p>
                    </Col>
                    <Col>
                      <p className='m-0 user-select-none'>{fileNameSelectedForDay}</p>
                    </Col>
                    <Col>

                    </Col>
                    <Col className='text-end'>
                      <label className='user-select-none'>Active Vehicle?</label><input type='checkbox' checked={activeVehCheckSelectedForDay} onChange={(e) => setActiveVehCheckSelectedForDay(e.target.checked)} className='mx-2' style={{ cursor: "pointer" }} />
                    </Col>
                  </Row>
                  <Row className='mx-1 mt-2 w-100'>
                    <Col xs={2}>
                      <p className='user-select-none m-0 mt-1'>Route#:</p>
                      <p className='user-select-none m-0 mt-4'>Vehicle#:</p>
                    </Col>
                    <Col xs={4}>
                      <input type='text' title={props?.data?.vVirtualRoute} className='text-nowrap user-select-none mt-1 d-block rounded border-1 p-1 w-100' style={{ width: "auto" }} disabled defaultValue={props.data?.vVirtualRoute} />
                      <select className='form-select text-center mt-2' value={vehNumSelectedForDay} onChange={handleChangeVehNumSelectedForDay}>
                        {VehOptionsManageHTML}
                      </select>
                    </Col>
                    <Col xs={2}>
                      <p className='user-select-none m-0 mt-1'>Depot#:</p>
                      <p className='user-select-none m-0 mt-4'>Veh.Type:</p>
                    </Col>
                    <Col xs={4}>
                      <select value={depotSelectedForDay} style={{ minWidth: "110px" }} onChange={(e) => { setDepotSelectedForDay(e.target.value) }} className='form-select text-center mt-1'>
                        {depotDropDownHTML}
                      </select>
                      <select
                        disabled={vehNumSelectedForDay > 0}
                        className='form-select text-center mt-2' value={vehTypeSelectedForDay} onChange={handleChangeVehTypeSelectedForDay}>
                        {VehTypeOptionsManageHTML}
                      </select>
                    </Col>
                  </Row>
                  <Row className="mx-1 position-relative p-1 text-start bg-white pe-none user-select-none text-secondary rounded text-nowrap" style={{ width: "fit-content", height: "26px" }}>Route Times</Row>
                  <Row className="mx-1 border border-secondary rounded overflow-auto w-100" style={{ marginTop: "-0.5%" }}>

                    <Row className="px-1 py-2 w-100 m-0">
                      <Col xs={2}>
                        <label className='user-select-none h6 text-nowrap mt-1'>Start Time:</label>
                      </Col>
                      <Col xs={4}>
                        <input type={"time"} className='text-nowrap d-inline-flex rounded border-1 p-1' onChange={(e) => setStartTimeSelectedForDay(e.target.value)} value={startTimeSelectedForDay} style={{ width: "fit-content" }} /> </Col>
                      <Col xs={2}>
                        <label className='user-select-none h6 text-nowrap mt-1'>Route Duration:</label>
                      </Col>
                      <Col xs={4}>
                        <input type={"text"} value={DurationSelectedForDay} className='text-nowrap  d-inline-block rounded border-1 p-1' onChange={(e) => setDurationSelectedForDay(e.target.value)} style={{ width: "150px" }} />
                      </Col>
                    </Row>
                  </Row>
                  <Row className="mx-1 position-relative p-1 text-start bg-white user-select-none text-secondary rounded text-nowrap" style={{ width: "fit-content", height: "26px" }}>
                    <Col className='m-0 p-0'>
                      Break Times
                    </Col>
                    <Col className='p-0'>
                      <Button variant='dark' className="border-0 mx-1 p-0 px-1" onClick={handleAddRowSelectedForDay} title={"Add Break"} style={{ width: "fit-content" }}>
                        +
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mx-1 border border-dark w-100 rounded overflow-auto" style={{ marginTop: "-0.5%", height: "150px" }}>
                    <Col>
                      {breakTimeRowsSelectedForDay?.map((item, index) => (
                        <Row className="p-1 px-2 border border-secondary" key={index}>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none d-inline-flex'>Start Time</p>
                            <input type={"time"} value={breakTimeRowInfoSelectedForDay[index].startTime} data-virtual={index}
                              onChange={handleUpdateBreakStartTimeChangeSelectedForDay}
                              className='text-nowrap p-1 rounded border-1 text-center' style={{ width: "fit-content" }}
                            />
                            <p style={{ cursor: "pointer", fontSize: "x-small" }} data-virtual={index}
                              className='d-inline-flex float-end m-0 mt-2 border border-dark px-1 user-select-none tripaction_btn_color' onClick={handleStartTimeClearSelectedForDay} title='Clear Start Time'>X
                            </p>
                          </Col>
                          <Col className='p-0 mx-1'>
                            <p className='m-0 text-nowrap user-select-none'>Start Hours</p>
                            <input type={"number"} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0}
                              value={breakTimeRowInfoSelectedForDay[index]?.startHour} data-virtual={index} onChange={handleUpdateBreakStartHourChangeSelectedForDay} />
                            <label className='user-select-none text-nowrap mx-1'>hrs</label>
                          </Col>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none'>Early Win.</p>
                            <input type={"number"} value={breakTimeRowInfoSelectedForDay[index]?.earlyWindow}
                              onChange={handleUpdateBreakEarlyWinChangeSelectedForDay} data-virtual={index} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0} />
                            <label className='user-select-none text-nowrap mx-1'>min</label>
                          </Col>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none'>Late Win.</p>
                            <input type={"number"} value={breakTimeRowInfoSelectedForDay[index]?.lateWindow}
                              onChange={handleUpdateBreakLateWinChangeSelectedForDay} data-virtual={index} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0} />
                            <label className='user-select-none text-nowrap mx-1'>min</label>
                          </Col>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none'>Duration</p>
                            <input type={"number"} value={breakTimeRowInfoSelectedForDay[index]?.duration}
                              onChange={handleUpdateBreakDurationChangeSelectedForDay} data-virtual={index} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0} />
                            <label className='user-select-none text-nowrap mx-1'>min</label>
                          </Col>
                          <Col className='p-0 d-flex justify-content-end' xs={1}>
                            <Button variant="dark" data-virtual={index} className='my-auto text-center' onClick={handleRemoveRowSelectedForDay} title='Remove Row'>
                              X
                            </Button>
                          </Col>
                        </Row>
                      ))}
                    </Col>
                  </Row>
                  {
                    (receivingAffiliatesDropDownHTML?.length > 1 || routeAttributeDropDownHTML?.length > 1) &&
                    <>
                      <Row className="mx-1 position-relative p-1 text-start bg-white pe-none user-select-none text-secondary rounded text-nowrap" style={{ width: "fit-content", height: "26px" }}>Default Only</Row>
                      <Row className="mx-1 border border-secondary rounded overflow-auto w-100" style={{ marginTop: "-0.5%" }}>
                        {
                          routeAttributeDropDownHTML?.length > 1 ?
                          <>
                            <Col xs={3}>
                              <label className='user-select-none m-0 mt-8'>Route Attributes:</label>
                            </Col>
                            <Col xs={3}>
                              <Row>
                                <div style={{ maxHeight: '100px', overflowY: 'auto', width: '100%', paddingLeft: '0px' }}>
                                  {routeAttributeDropDownHTML?.map((item, index) => {
                                    if (!item || !item?.props) {
                                      return null;
                                    }
                                    const { value, children } = item.props;

                                    if (value === '-1') {
                                      return null;
                                    }
                                    const isSelected = selectedAttributes?.some(attr => attr.iAttributeID === parseInt(value));

                                    return (
                                      <Col xs={12} key={index} className="d-flex align-items-center" style={{ paddingLeft: '0px' }}>
                                        <input
                                          type="checkbox"
                                          id={`routeAttribute_${value}`}
                                          name="routeAttribute"
                                          value={value}
                                          readOnly
                                          disabled
                                          checked={isSelected}
                                          className="me-2"
                                        />
                                        <label
                                          htmlFor={`routeAttribute_${value}`}
                                          className="user-select-none"
                                          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                        >
                                          {children}
                                        </label>
                                      </Col>
                                    );
                                  })}
                                </div>


                              </Row>
                            </Col>
                          </>: <><Col xs={3}>
                            </Col>
                              <Col xs={3}>
                              </Col></>
                        }

                        {
                          receivingAffiliatesDropDownHTML?.length > 1 &&
                          <>
                            <Col xs={3}>
                              <label className='user-select-none m-0 mt-8'>Receiving Affiliate:</label>
                            </Col>
                            <Col xs={3}>
                              <p className='text-center mt-1' style={{ minWidth: "110px" }}>
                                {receivingAffiliatesDropDownHTML?.find((item) => item?.props?.value == receivingAffiliates)?.props.children || 'No Affiliate Selected'}
                              </p>
                            </Col>
                          </>
                        }
                      </Row>
                    </>
                  }
                </div>
                <Modal.Footer>
                  <Button variant='dark' className="border-0" onClick={() => handleUpdateRouteSettings("selectedDay")}>
                    Update
                  </Button>
                  <Button variant='dark' className="border-0" onClick={handleApplyDefaultSetup}>
                    Apply Default Setup
                  </Button>
                  <Button variant='dark' className="border-0" onClick={handleCloseModal}>
                    Close
                  </Button>
                </Modal.Footer>
              </Tab>
              <Tab eventKey="selectedDefaultSetup" title="Default setup">
                <div className="p-4">
                  <Row className='w-100'>
                    <Col>
                      <p className='m-0 mx-1 user-select-none'>Selected File Name:</p>
                    </Col>
                    <Col>
                      <p className='m-0 user-select-none'>{fileName}</p>
                    </Col>
                    <Col>

                    </Col>
                    <Col className='text-end'>
                      <label className='user-select-none'>Active Vehicle?</label><input type='checkbox' checked={activeVehCheck} onChange={(e) => setActiveVehCheck(e.target.checked)} className='mx-2' style={{ cursor: "pointer" }} />
                    </Col>
                  </Row>
                  <Row className='mx-1 mt-2 w-100'>
                    <Col xs={2}>
                      <p className='user-select-none m-0 mt-1'>Route#:</p>
                      <p className='user-select-none m-0 mt-4'>Vehicle#:</p>
                    </Col>
                    <Col xs={4}>
                      <input type='text' title={props.data?.vVirtualRoute} className='text-nowrap user-select-none mt-1 d-block rounded border-1 p-1 w-100' style={{ width: "auto" }} disabled defaultValue={props.data?.vVirtualRoute} />
                      <select className='form-select text-center mt-2' value={vehNum} onChange={handleChangeVehNum}>
                        {VehOptionsManageHTML}
                      </select>
                    </Col>
                    <Col xs={2}>
                      <p className='user-select-none m-0 mt-1'>Depot#:</p>
                      <p className='user-select-none m-0 mt-4'>Veh.Type:</p>
                    </Col>
                    <Col xs={4}>
                      <select value={depotSelected} style={{ minWidth: "110px" }} onChange={(e) => { setDepotSelected(e.target.value) }} className='form-select text-center mt-1'>
                        {depotDropDownHTML}
                      </select>
                      <select
                        disabled={vehNum > 0}
                        className='form-select text-center mt-2' value={vehType} onChange={handleChangeVehType}>
                        {VehTypeOptionsManageHTML}
                      </select>
                    </Col>
                  </Row>
                  <Row className="mx-1 position-relative p-1 text-start bg-white pe-none user-select-none text-secondary rounded text-nowrap" style={{ width: "fit-content", height: "26px" }}>Route Times</Row>
                  <Row className="mx-1 border border-secondary rounded overflow-auto w-100" style={{ marginTop: "-0.5%" }}>
                    <Row className="px-1 py-2 w-100 m-0">
                      <Col xs={2}>
                        <label className='user-select-none h6 text-nowrap mt-1'>Start Time:</label>
                      </Col>
                      <Col xs={4}>
                        <input type={"time"} className='text-nowrap d-inline-flex rounded border-1 p-1' onChange={(e) => setStartTime(e.target.value)} value={startTime} style={{ width: "fit-content" }} /> </Col>
                      <Col xs={2}>
                        <label className='user-select-none h6 text-nowrap mt-1'>Route Duration:</label>
                      </Col>
                      <Col xs={4}>
                        <input type={"text"} value={Duration} className='text-nowrap  d-inline-block rounded border-1 p-1' onChange={(e) => setDuration(e.target.value)} style={{ width: "150px" }} />
                      </Col>
                    </Row>
                  </Row>
                  <Row className="mx-1 position-relative p-1 text-start bg-white user-select-none text-secondary rounded text-nowrap" style={{ width: "fit-content", height: "26px" }}>
                    <Col className='m-0 p-0'>
                      Break Times
                    </Col>
                    <Col className='p-0'>
                      <Button variant='dark' className="border-0 mx-1 p-0 px-1" onClick={handleAddRow} title={"Add Break"} style={{ width: "fit-content" }}>
                        +
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mx-1 border border-dark w-100 rounded overflow-auto" style={{ marginTop: "-0.5%", height: "150px" }}>
                    <Col>
                      {breakTimeRows.map((item, index) => (
                        <Row className="p-1 px-2 border border-secondary" key={index}>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none d-inline-flex'>Start Time</p>
                            <input type={"time"} value={breakTimeRowInfo[index]?.startTime} data-virtual={index}
                              onChange={handleUpdateBreakStartTimeChange}
                              className='text-nowrap p-1 rounded border-1 text-center' style={{ width: "fit-content" }}
                            />
                            <p style={{ cursor: "pointer", fontSize: "x-small" }} data-virtual={index}
                              className='d-inline-flex float-end m-0 mt-2 border border-dark px-1 user-select-none tripaction_btn_color' onClick={handleStartTimeClear} title='Clear Start Time'>X
                            </p>
                          </Col>
                          <Col className='p-0 mx-1'>
                            <p className='m-0 text-nowrap user-select-none'>Start Hours</p>
                            <input type={"number"} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0}
                              value={breakTimeRowInfo[index]?.startHour} data-virtual={index} onChange={handleUpdateBreakStartHourChange} />
                            <label className='user-select-none text-nowrap mx-1'>hrs</label>
                          </Col>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none'>Early Win.</p>
                            <input type={"number"} value={breakTimeRowInfo[index]?.earlyWindow}
                              onChange={handleUpdateBreakEarlyWinChange} data-virtual={index} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0} />
                            <label className='user-select-none text-nowrap mx-1'>min</label>
                          </Col>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none'>Late Win.</p>
                            <input type={"number"} value={breakTimeRowInfo[index]?.lateWindow}
                              onChange={handleUpdateBreakLateWinChange} data-virtual={index} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0} />
                            <label className='user-select-none text-nowrap mx-1'>min</label>
                          </Col>
                          <Col className='p-0'>
                            <p className='m-0 text-nowrap user-select-none'>Duration</p>
                            <input type={"number"} value={breakTimeRowInfo[index]?.duration}
                              onChange={handleUpdateBreakDurationChange} data-virtual={index} className='text-nowrap p-1 rounded border-1 text-center w-50' min={0} />
                            <label className='user-select-none text-nowrap mx-1'>min</label>
                          </Col>
                          <Col className='p-0 d-flex justify-content-end' xs={1}>
                            <Button variant="dark" data-virtual={index} className='my-auto text-center' onClick={handleRemoveRow} title='Remove Row'>
                              X
                            </Button>
                          </Col>
                        </Row>
                      ))}
                    </Col>
                  </Row>
                  {
                    (receivingAffiliatesDropDownHTML?.length > 1 || routeAttributeDropDownHTML?.length > 1) &&
                    <>
                      <Row className="mx-1 position-relative p-1 text-start bg-white pe-none user-select-none text-secondary rounded text-nowrap" style={{ width: "fit-content", height: "26px" }}>Default Only</Row>
                      <Row className="mx-1 py-2 border border-secondary rounded w-100 align-items-center" style={{ marginTop: "-0.5%" }}>
                        {
                          routeAttributeDropDownHTML?.length > 1 ?
                            <>
                              <Col xs={3}>
                                <label className="user-select-none m-0">Route Attributes:</label>
                              </Col>
                              <Col xs={3}>
                                <Dropdown style={{ zIndex: "20", height: "100%", width: "100%" }}>
                                  <Dropdown.Toggle variant="outline-secondary" className="custom-dropdown-btn w-100">
                                    {selectedOptions?.length > 0
                                      ? `Selected (${selectedOptions.length})`
                                      : 'Select Options'}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    {routeAttributeDropDownHTML?.map((item, index) => {
                                      const value = String(item?.props?.value);
                                      const isSelected = selectedOptions?.includes(value);

                                      return (
                                        <Form.Check
                                          key={index}
                                          id={`attribute_${index}`}
                                          type="checkbox"
                                          label={item?.props?.children}
                                          checked={isSelected}
                                          onChange={() => handleSelect(value)}
                                        />
                                      );
                                    })}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </Col>
                            </> : <><Col xs={3}>
                            </Col>
                              <Col xs={3}>
                              </Col></>
                        }

                        {
                          receivingAffiliatesDropDownHTML?.length > 1 &&
                          <>
                            <Col xs={3}>
                              <label className="user-select-none m-0">Receiving Affiliate:</label>
                            </Col>
                            <Col xs={3}>
                              <select
                                value={receivingAffiliates}
                                style={{ minWidth: "110px" }}
                                onChange={(e) => setSelectedReceivingAffiliates(e.target.value)}
                                className="form-select text-center"
                              >
                                {receivingAffiliatesDropDownHTML}
                              </select>
                            </Col>
                          </>
                        }
                      </Row>
                    </>
                  }

                </div>
                <Modal.Footer>
                  <Button variant='dark' className="border-0" onClick={() => handleUpdateRouteSettings("defaultDay")}>
                    Update
                  </Button>
                  <Button variant='dark' className="border-0" onClick={handleDeleteRoute}>
                    Delete Route
                  </Button>
                  <Button variant='dark' className="border-0" onClick={handleCloseModal}>
                    Close
                  </Button>
                </Modal.Footer>
              </Tab>
            </Tabs>
          </div>
        </Modal>
        : ""}

      {showModal ? <Modal centered backdrop="static" keyboard={true} onHide={handleModalClose} show={showModal} animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>{modalHeaderText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalBodyHTML}</Modal.Body>
        <Modal.Footer>

          {modalBtnHTML}

        </Modal.Footer>
      </Modal> : ""}

      <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
        onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
        btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />

    </>
  );
};

export default EditRouteSettings;
